(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nex3d-approved-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const toggle=event.target.closest('.nx-search-toggle');if(!toggle)return;const header=toggle.closest('.nx-header');const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));header.classList.toggle('nx-search-open',open);if(open)header.querySelector('.nx-search input').focus();});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const header=event.target.closest('.nx-header');if(!header)return;header.classList.remove('nx-search-open');const toggle=header.querySelector('.nx-search-toggle');if(toggle?.getAttribute('aria-expanded')==='true'){toggle.setAttribute('aria-expanded','false');toggle.focus();}});
document.addEventListener('click',event=>{document.querySelectorAll('.nx-store-selector[open]').forEach(selector=>{if(!selector.contains(event.target))selector.removeAttribute('open');});});
document.addEventListener('keydown',event=>{if(event.key!=='Escape')return;const selector=document.querySelector('.nx-store-selector[open]');if(selector){selector.removeAttribute('open');selector.querySelector('summary').focus();}});

(() => {
  const menus = [...document.querySelectorAll('[data-nx-mega]')];
  const desktop = matchMedia('(min-width: 761px) and (hover: hover)');
  const closeOthers = current => menus.forEach(menu => { if (menu !== current) menu.open = false; });
  menus.forEach(menu => {
    let timer;
    const open = () => { clearTimeout(timer); closeOthers(menu); menu.open = true; };
    menu.addEventListener('pointerenter', event => { if (desktop.matches && event.pointerType === 'mouse') open(); });
    menu.addEventListener('pointerleave', () => { if (desktop.matches) timer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180); });
    menu.addEventListener('focusin', () => { if (desktop.matches) open(); });
    menu.addEventListener('focusout', () => { if (desktop.matches) setTimeout(() => { if (!menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0); });
    menu.addEventListener('toggle', () => { if (menu.open) closeOthers(menu); });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !menu.open) return;
      event.preventDefault(); event.stopPropagation();
      menu.open = false;
      menu.querySelector('summary').focus();
      menu.open = false;
    });
  });
  document.addEventListener('click', event => { if (!event.target.closest('[data-nx-mega]')) closeOthers(null); });
  document.querySelector('.nx-menu-toggle')?.addEventListener('click', () => closeOthers(null));
})();


document.querySelectorAll('[data-nx-mega]').forEach(menu => {
  const tabs = [...menu.querySelectorAll('[data-nx-category]')];
  const select = tab => {
    tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      menu.querySelector(`#${item.getAttribute('aria-controls')}`).hidden = !active;
    });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') select(tab); });
    tab.addEventListener('focus', () => select(tab));
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      const direction = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[event.key];
      if (direction) { event.preventDefault(); tabs[(index + direction + tabs.length) % tabs.length].focus(); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); tabs[event.key === 'Home' ? 0 : tabs.length - 1].focus(); }
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nex3d-article-reader"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nex3d-article-reader')) {
    customElements.define('nex3d-article-reader', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        this.dataset.enhanced = 'true';
        const body = this.querySelector('.nex3d-article-reader__body');
        const nav = this.querySelector('.nex3d-article-reader__contents');
        const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
        if (headings.length < 3) return;
        const list = nav.querySelector('ol');
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `GuideSection-${this.dataset.articleId}-${index + 1}`;
          heading.tabIndex = -1;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        nav.hidden = false;
        const hash = window.location.hash.slice(1);
        const initialHeading = headings.find((heading) => heading.id === hash);
        if (initialHeading) requestAnimationFrame(() => initialHeading.scrollIntoView());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nex3d-color-feedback"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-another-color]');
  if (!button) return;
  const info = button.closest('product-info');
  const quantity = info.querySelector('input[name="quantity"]');
  if (quantity) { quantity.value = quantity.min || '1'; quantity.dispatchEvent(new Event('change', {bubbles:true})); }
  const picker = info.querySelector('variant-selects');
  picker?.scrollIntoView({behavior:'smooth',block:'center'});
  picker?.querySelector('input[type="radio"]:checked,select')?.focus({preventScroll:true});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nex3d-mobile-purchase-shortcut"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nex3d-mobile-purchase')) customElements.define('nex3d-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.button = this.querySelector('[data-mobile-submit]');
      if (!this.product || !this.button) return;
      this.sync = () => {
        const original = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        if (!original) { this.button.disabled = true; return; }
        this.button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
        const label = original.querySelector('span:not(.loading__spinner)');
        if (label && this.button.textContent !== label.textContent.trim()) this.button.textContent = label.textContent.trim();
        const price = document.getElementById(`price-${this.dataset.section}`)?.querySelector('.price');
        const current = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        if (current) this.querySelector('[data-mobile-price]').textContent = current.textContent.trim();
        const picker = this.product.querySelector('variant-selects');
        const names = picker ? [...picker.querySelectorAll('select option:checked, input[type=radio]:checked')].map(el => el.value) : [];
        const qty = this.product.querySelector('input[name=quantity]')?.value || '1';
        this.querySelector('[data-mobile-selection]').textContent = [...names, `× ${qty}`].join(' / ');
      };
      this.button.addEventListener('click', () => {
        const original = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        if (original && !original.disabled && original.getAttribute('aria-disabled') !== 'true') original.click();
      });
      this.product.addEventListener('change', this.sync);
      this.observer = new MutationObserver(mutations => {
        if (mutations.some(m => !this.contains(m.target))) this.sync();
      });
      this.observer.observe(this.product, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled','class']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.product?.removeEventListener('change', this.sync);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nex3d-predictive"] && !Shopify.designMode) return;
  try {
    function nxSetupSuggestions(){
const form=document.querySelector('#nx-header-search');if(!form||form.dataset.suggestionsReady)return;form.dataset.suggestionsReady='true';
const input=form.querySelector('input[name="q"]'),panel=form.querySelector('.nx-suggest'),body=panel.querySelector('.nx-suggest-body'),status=panel.querySelector('.nx-suggest-status'),initial=body.innerHTML;
let timer,controller,sequence=0;const cache=new Map();
input.setAttribute('autocomplete','off');input.setAttribute('aria-controls',panel.id);input.setAttribute('aria-expanded','false');
const close=()=>{sequence++;clearTimeout(timer);controller?.abort();panel.hidden=true;input.setAttribute('aria-expanded','false');status.textContent='';};
const open=()=>{panel.hidden=false;input.setAttribute('aria-expanded','true');};
const search=async()=>{const q=input.value.trim(),id=++sequence;controller?.abort();open();if(!q){body.innerHTML=initial;status.textContent='';return;}if(cache.has(q)){body.innerHTML=cache.get(q);status.textContent='';return;}
body.replaceChildren();const pending=document.createElement('p');pending.textContent=panel.dataset.loading;body.append(pending);status.textContent=panel.dataset.loading;controller=new AbortController();
try{const url=new URL(panel.dataset.endpoint,location.origin);url.searchParams.set('q',/^pla$/i.test(q)?'PLA filament':q);url.searchParams.set('resources[type]','product,query');url.searchParams.set('resources[limit]','4');url.searchParams.set('resources[limit_scope]','each');url.searchParams.set('resources[options][unavailable_products]','last');url.searchParams.set('section_id','nex3d-predictive-results');
const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw new Error('Search unavailable');const html=await response.text();if(id!==sequence)return;const doc=new DOMParser().parseFromString(html,'text/html');const result=doc.querySelector('#shopify-section-nex3d-predictive-results');if(!result)throw new Error('Missing search section');if(cache.size>20)cache.clear();cache.set(q,result.innerHTML);body.innerHTML=result.innerHTML;status.textContent=body.querySelector('.nx-suggest-all')?.textContent||'';
}catch(error){if(error.name==='AbortError'||id!==sequence)return;body.replaceChildren();const link=document.createElement('a');link.className='nx-suggest-all';const url=new URL(form.action);url.searchParams.set('q',q);link.href=url.href;link.textContent=panel.dataset.error;body.append(link);status.textContent=panel.dataset.error;}};
input.addEventListener('focus',search);input.addEventListener('input',()=>{sequence++;controller?.abort();clearTimeout(timer);timer=setTimeout(search,180);});
form.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden){event.preventDefault();event.stopPropagation();input.focus();close();}else if(event.key==='ArrowDown'&&event.target===input&&!panel.hidden){event.preventDefault();body.querySelector('a')?.focus();}});
panel.querySelector('.nx-suggest-close').addEventListener('click',()=>{input.focus();close();});
document.addEventListener('pointerdown',event=>{if(!form.contains(event.target))close();});
form.addEventListener('focusout',()=>{setTimeout(()=>{if(!form.contains(document.activeElement))close();},0);});
form.addEventListener('submit',close);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',nxSetupSuggestions);else nxSetupSuggestions();document.addEventListener('shopify:section:load',nxSetupSuggestions);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nex3d-ux-refresh"] && !Shopify.designMode) return;
  try {
    (() => {
    const tray = document.querySelector('.nex3d-compare-tray');
    if (!tray) return;
    const selected = new Map();
    const link = tray.querySelector('[data-compare-link]');
    const status = tray.querySelector('[data-compare-status]');
    const hint = status.textContent;
    const update = () => {
      tray.hidden = selected.size === 0;
      tray.querySelector('[data-compare-count]').textContent = `(${selected.size}/4)`;
      status.textContent = selected.size > 0 ? [...selected.values()].join(' · ') : hint;
      link.setAttribute('aria-disabled', String(selected.size < 2));
      if (selected.size >= 2) link.href = `${link.dataset.base}?compare=${encodeURIComponent([...selected.keys()].join(','))}#compare`;
      else link.removeAttribute('href');
      document.querySelectorAll('[data-nex-compare]').forEach(input => { input.checked = selected.has(input.dataset.nexCompare); });
    };
    document.addEventListener('change', event => {
      const input = event.target.closest('[data-nex-compare]');
      if (!input) return;
      if (input.checked && selected.size >= 4 && !selected.has(input.dataset.nexCompare)) {
        input.checked = false;
        status.textContent = tray.dataset.maxMessage;
        return;
      }
      if (input.checked) selected.set(input.dataset.nexCompare, input.dataset.title);
      else selected.delete(input.dataset.nexCompare);
      update();
    });
    tray.querySelector('[data-compare-clear]').addEventListener('click', () => { selected.clear(); update(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.collectionUpdate) subscribe(PUB_SUB_EVENTS.collectionUpdate, update);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nex3d-warranty-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nex3d-warranty-picker')) {
    customElements.define(
      'nex3d-warranty-picker',
      class Nex3dWarrantyPicker extends HTMLElement {
        connectedCallback() {
          this.status = this.querySelector('.nex3d-warranty-picker__status');
          this.addEventListener('change', this.handleSelectionChange.bind(this));

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
          }

          this.updateExpressCheckout();
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }

        handleSelectionChange(event) {
          if (!event.target.matches('.nex3d-warranty-picker__input')) return;
          this.status.hidden = true;
          this.status.removeAttribute('data-state');
          this.updateExpressCheckout();
        }

        updateExpressCheckout() {
          const selected = this.querySelector('.nex3d-warranty-picker__input:checked');
          const summary = this.querySelector('[data-warranty-summary]');
          if (summary) summary.textContent = selected?.closest('label')?.querySelector('.nex3d-warranty-picker__name')?.textContent || '';
          const paymentButton = this.closest('product-info')?.querySelector('.shopify-payment-button');
          if (paymentButton) paymentButton.hidden = Boolean(selected?.value);
        }

        async handleCartUpdate(event) {
          if (event?.source !== 'product-form' || !event.cartData) return;

          const selected = this.querySelector('.nex3d-warranty-picker__input:checked');
          if (!selected?.value) return;

          const form = document.getElementById(this.dataset.productFormId);
          const productVariantId = form?.elements.namedItem('id')?.value;
          if (!productVariantId || String(event.productVariantId) !== String(productVariantId)) return;

          const requestedQuantity = Number.parseInt(form.elements.namedItem('quantity')?.value, 10);
          const quantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const payload = {
            items: [{ id: Number(selected.value), quantity }],
            sections_url: window.location.pathname,
          };

          if (cart) payload.sections = cart.getSectionsToRender().map((section) => section.id);

          this.setAttribute('aria-busy', 'true');

          try {
            const response = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(payload),
            });
            const result = await response.json();

            if (!response.ok || result.status) throw new Error(result.description || result.message);
            if (result.sections) {
              event.cartData.sections = result.sections;

              if (cart) {
                const renderedResult = Array.isArray(result.items)
                  ? { ...result.items[0], sections: result.sections }
                  : result;
                cart.renderContents(renderedResult);
              }
            }

            this.status.textContent = this.dataset.addedMessage;
            this.status.hidden = false;
            this.status.dataset.state = 'success';
            this.querySelector('.nex3d-warranty-picker__input[value=""]').checked = true;
            this.updateExpressCheckout();
          } catch (error) {
            this.status.textContent = this.dataset.errorMessage;
            this.status.hidden = false;
            this.status.dataset.state = 'error';
          } finally {
            this.removeAttribute('aria-busy');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
